"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Listboxes = void 0;
var react_1 = __importDefault(require("react"));
var SelectComponents_1 = require("./SelectComponents");
var SelectUtils_1 = require("./SelectUtils");
var useSelect_1 = require("./useSelect");
exports.Listboxes = function (props) {
    var _a = SelectUtils_1.useSelectProps(props), useSelectConfiguration = _a.useSelectConfiguration, inputProps = _a.inputProps, customComponents = _a.customComponents;
    var components = __assign(__assign({}, SelectComponents_1.defaultListboxComponents), customComponents);
    var Container = components.Container, Listbox = components.Listbox, OptionContainer = components.OptionContainer, Option = components.Option;
    var _b = useSelect_1.useSelect(props), isSearching = _b.isSearching, searchQuery = _b.searchQuery, onSearchChange = _b.onSearchChange, highlightedOption = _b.highlightedOption, setHighlightedOption = _b.setHighlightedOption, selectedOptions = _b.selectedOptions, onSelect = _b.onSelect, setSelectedOptions = _b.setSelectedOptions, inputValue = _b.inputValue, options = _b.options, flattenedOptions = _b.flattenedOptions, onKeyDown = _b.onKeyDown, setHighlightedEl = _b.setHighlightedEl, setSearchableInputEl = _b.setSearchableInputEl;
    // EVENT HANDLING
    var onDeselectAllClick = function () {
        setSelectedOptions([]);
    };
    var onSelectAllClick = function () {
        setSelectedOptions(flattenedOptions);
    };
    // RENDERING
    var renderOption = function (option, isSelected) {
        var isHighlighted = option === highlightedOption;
        var ref = isHighlighted ? setHighlightedEl : undefined;
        return (react_1.default.createElement(OptionContainer, { ref: ref, isHighlighted: isHighlighted, onClick: function (e) {
                e.preventDefault();
                onSelect(option);
            }, onMouseEnter: function () { return setHighlightedOption(option); }, onMouseLeave: function () { return setHighlightedOption(undefined); } },
            react_1.default.createElement(Option, { multiple: props.multiple || false, option: option, isHighlighted: isHighlighted, isSelected: isSelected })));
    };
    var renderGroup = function (group, renderSelected) {
        if (!group.options || group.options.length === 0) {
            return null;
        }
        var options = group.options.filter(function (option) { return selectedOptions.includes(option) === renderSelected; });
        if (options.length === 0) {
            return null;
        }
        return __spreadArrays([
            react_1.default.createElement("p", { className: "c-dropdown__group" }, group.heading)
        ], options.map(function (option) { return renderOption(option, renderSelected); }));
    };
    var renderOptions = function () {
        if (options.length === 0) {
            return (react_1.default.createElement("div", { className: "u-align-center u-pad-small u-color-light" }, props.noOptionsText || "No options available"));
        }
        return options.map(function (option) {
            if ("options" in option) {
                return renderGroup(option, false);
            }
            else {
                if (selectedOptions.includes(option)) {
                    return;
                }
                return renderOption(option, false);
            }
        });
    };
    var renderSelected = function () {
        if (selectedOptions.length === 0) {
            return (react_1.default.createElement("div", { className: "u-align-center u-pad-small u-color-light" }, props.noSelectedText || "No selected options"));
        }
        // TODO the order of the options is preserved when rendering selected
        // options. This should be rewritten to keep the order as they were
        // selected.
        return options.map(function (option) {
            if ("options" in option) {
                return renderGroup(option, true);
            }
            else {
                if (!selectedOptions.includes(option)) {
                    return;
                }
                return renderOption(option, true);
            }
        });
    };
    return (react_1.default.createElement(Container, { className: "l-grid +fill +cols-auto u-height-2" },
        react_1.default.createElement(Listbox, null, renderOptions()),
        react_1.default.createElement("div", { className: "u-flex u-align-items-center u-flex-dir-col" },
            react_1.default.createElement("button", { className: "c-button +quiet u-marg-bottom", onClick: onDeselectAllClick }, "< Deselect all  "),
            react_1.default.createElement("button", { className: "c-button +quiet", onClick: onSelectAllClick }, "  Select all   >")),
        react_1.default.createElement(Listbox, null, renderSelected()),
        react_1.default.createElement("input", __assign({}, inputProps, { type: "hidden", value: inputValue }))));
};
//# sourceMappingURL=Listboxes.js.map